import Box from '@mui/material/Box';
import React, { memo } from 'react';

type SpeedSegmentProps = {
  position: string;
  speed: number;
  maxSpeed: number;
};

const SpeedSegment = ({ position, speed, maxSpeed }: SpeedSegmentProps) => {
  if (maxSpeed <= 0) return null;
  const ratio = Math.min(Math.max(speed / maxSpeed, 0), 1);
  const speedTop = `${(1 - ratio) * 100}%`;

  return (
    <Box
      sx={{
        position: 'absolute',
        left: position,
        top: speedTop,
        width: '1px',
        bottom: 0,
        backgroundColor: '#78B2FF',
      }}
    />
  );
};

export default memo<SpeedSegmentProps>(SpeedSegment);
